export const GET_ALL_BLOG = 'get_all_blog'
export const BLOG_ERROR = 'blog_error'
export const GET_BLOG_DETAILS = 'blog_details'
